import React, { FC, useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useTranslation } from 'react-i18next';

type RadioBtnTypeSettingProps = {
    setting: string[];
    propertyName: string;
    settingValue: string;
    handlePropertySelection: (propertyName: string, settingValue: string) => void;
};

const RadioBtnTypeSetting: FC<RadioBtnTypeSettingProps> = ({
    setting,
    propertyName,
    settingValue,
    handlePropertySelection,
}: RadioBtnTypeSettingProps) => {
    const [value, setValue] = React.useState('');
    const { t: translate } = useTranslation(['construction-props']);

    useEffect(() => {
        if (settingValue) {
            setValue(settingValue);
        }
    }, [settingValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
        handlePropertySelection(propertyName, (event.target as HTMLInputElement).value);
    };

    return (
        <FormControl component="fieldset">
            <RadioGroup value={value} onChange={handleChange}>
                {setting.map((elem) => (
                    <FormControlLabel
                        key={elem}
                        value={elem}
                        control={<Radio color="secondary" />}
                        label={translate(elem)}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default RadioBtnTypeSetting;
